import React, { useState, useEffect, useContext, useRef } from "react";
import { DataGrid, gridClasses } from "@mui/x-data-grid";

import { Link, useNavigate } from "react-router-dom";

import draftToHtml from "draftjs-to-html";
import ReactHtmlParser from "react-html-parser";

import update from "immutability-helper";
import FormControlLabel from "@mui/material/FormControlLabel";

import FormControl from "@mui/material/FormControl";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import InfoIcon from "@mui/icons-material/Info";

import AlertDialog from "../../components/AlertDialog.js";

import { REFRESH_TOKEN_MUTATION } from "../../graphQL/user_qry";
import { GET_COMPONENTS_ANSWERS_BY_FORM_ID_QUERY } from "../../graphQL/component_qry";
import {
  APPLICANT_ANSWERS_BY_TERM_APPLICANT_ID_QUERY,
  EDIT_TERM_APPLICANT_ANSWER_MUTATE,
} from "../../graphQL/term_applicant_answer_qry";
import { EDIT_TERM_APPLICANT_MUTATE } from "../../graphQL/term_applicant_qry";

import {
  useQuery,
  useManualQuery,
  useMutation,
  ClientContext,
} from "graphql-hooks";

import {
  Container,
  Card,
  CardContent,
  Grid,
  Typography,
  Divider,
  TextField,
  Radio,
  RadioGroup,
  Checkbox,
  Tooltip,
  Button,
  IconButton,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  DialogContentText,
  FormHelperText,
  makeStyles,
} from "@material-ui/core";
import Box from "@mui/material/Box";
import styled from "styled-components";

import Header from "./Header.js";
import SelectQuestionDialog from "./selectQuestionDialog.js";
import CompareTextAreaDialog from "./compareTextAreaDialog.js";
import { project_url } from "../../constants/Data";

var findAnd = require("find-and");
const StyledTooltip = styled((props) => (
  <Tooltip
    classes={{ popper: props.className }}
    {...props}
    PopperProps={{
      popperOptions: {
        modifiers: {
          flip: { enabled: false },
          offset: {
            offset: "185px, -20px, 20px, -180px", //"120px, -20px, 20px, -5px", //-75px, -40px, 20px, -25px",
          },
        },
      },
    }}
  />
))`
  & .MuiTooltip-tooltip {
    min-width: 340px;
    background: #fff;
    color: #000;
    border-radius: 8px;
    border: 1px solid #e0e0e0;
    font-size: 12px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0.4px;
    display: flex;
    padding: 8px 5px 8px 5px;
    flex-direction: column;
  }
`;

const StyledTooltipCom = styled((props) => (
  <Tooltip
    classes={{ popper: props.className }}
    {...props}
    PopperProps={{
      popperOptions: {
        modifiers: {
          flip: { enabled: false },
          offset: {
            offset: "0px, -50px, 20px, -25px",
          },
        },
      },
    }}
  />
))`
  & .MuiTooltip-tooltip {
    display: flex;
    background: #757575;
    color: #fff;
    border-radius: 4px;
    font-size: 10px;
    font-weight: 500;
  }
`;

const useStyles = makeStyles((theme) => ({
  root: {
    marginRight: "8rem",
    //textAlign: "center",
    padding: theme.spacing(2),
    paddingLeft: 0,
    paddingRight: 0,
    width: "1400px",
    paddingTop: "7.5rem",
    //  minWidth: "500px",
  },
  container: {
    padding: theme.spacing(4),
    marginTop: "1rem",
    marginBottom: "5rem",
    overflow: "hidden",
    clear: "both",
    borderRadius: "8px",
    minHeight: "870px",
    backgroundColor: "#ffffff",
  },
  outlinedButtonStyle: {
    borderRadius: 8,
    width: "110px",
    padding: 0,
    height: "48px",
    textTransform: "none",
  },
  errorStyle: {
    marginTop: 0,
    fontSize: 14, //16,
    fontFamily: "Arial",
    paddingLeft: 5,
  },
  buttonStyle: {
    borderRadius: 4,
    width: "250px",
    padding: 0,
    color: "#fff",
    height: "40px",
    backgroundColor: "#0D47A1",
    textTransform: "none",
    "&:hover": {
      backgroundColor: "#1E88E5",
    },
  },
  dataGridStyle: {
    width: "100%",
    "& .super-app-theme--header": {
      backgroundColor: "#99D4FF",
      color: "#0D47A1",
      fontSize: 18,
      fontWeight: 700,
    },
    "& .MuiDataGrid-columnHeaderTitle": {
      whiteSpace: "normal",
      lineHeight: "normal",
      textAlign: "center",
    },

    "& .MuiDataGrid-scrollbarFiller": {
      //  backgroundColor: "#99D4FF"  EFFFCA
    },
    "& .MuiDataGrid-cell": {
      fontSize: 16,
      fontWeight: 400,
      display: "flex",
      alignItems: "center",
      minHeight: 50,
    },
    "& .MuiDataGrid-columnHeader .MuiDataGrid-columnSeparator": {
      display: "none",
    },
    "& .MuiDataGrid-row": {
      backgroundColor: "#E3F2FD !important",
    },
    "& .MuiDataGrid-cell[data-field='question']": {
      backgroundColor: "#EFFFCA",
    },
    [`& .${gridClasses.cell}.colSpan[data-field='applicantAnswer2']`]: {
      justifyContent: "center",
    },
    [`& .${gridClasses.cell}.totalScore`]: {
      padding: 0,
      height: 56,
      marginBottom: 0,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: "#99D4FF",
    },
    [`& .${gridClasses.cell}.totalScore[data-field='question']`]: {
      padding: 0,
      backgroundColor: "#EFFFCA",
    },

    "&.MuiDataGrid-root .MuiDataGrid-columnHeader:focus, &.MuiDataGrid-root .MuiDataGrid-cell:focus": {
      outline: "none !important",
    },
    "&.MuiDataGrid-cell:focus-within": {
      outline: " none !important",
    },
  },
  textFieldStyle: {
    minwidth: 80,
    width: 80,
    "& .MuiInputLabel-outlined": {
      fontSize: 16,
    },
    "& .MuiOutlinedInput-root": {
      backgroundColor: "#fff",
      height: 40,
      borderRadius: 10,
      fontSize: 16,
      display: "flex",
      justifyContent: "center",
    },
    "& .MuiOutlinedInput-input": {
      textAlign: "center",
      paddingLeft: 20,
    },
  },
  datePickerStyle: {
    marginBottom: 5,
    "& .MuiInputLabel-outlined": {
      fontSize: 16,
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: 10,
      fontSize: 16,
    },
  },
  dataGridFooterStyle: {
    height: 56,
    marginBottom: 0,
    display: "flex",
    alignItems: "center",
    backgroundColor: "#99D4FF",
  },
  dataGridFooterTextStyle: {
    color: "#0D47A1",
    fontSize: 18,
    fontWeight: 700,
    textAlign: "center",
    //marginLeft: 22,
  },
}));

function ApplicantsOneOnOne({
  applicants,
  applySelectedQues,
  applyNewTotalAwardedScores,
  initQuesList,
}) {
  const [loadContent, setLoadContent] = useState(false);
  const client = useContext(ClientContext);
  const navigate = useNavigate();
  const [pathname] = useState(window.location.pathname);
  const [applicantsDetail, setApplicantsDetail] = useState([]); // all applicants detail rows
  const [detailRows, setDetailRows] = useState([]); // will be updated by selecting the questions
  const [openSelQuesDlg, setOpenSelQuesDlg] = useState(false);
  const [openCompareTextAreaDlg, setOpenCompareTextAreaDlg] = useState(false);
  const [quesList, setQuesList] = useState(initQuesList);
  const [applicantFormData, setApplicantFormData] = useState([]);
  const [applicant1Answers, setApplicant1Answers] = useState([]);
  const [applicant2Answers, setApplicant2Answers] = useState([]);
  const [errorMsg, setErrorMsg] = useState({ noOfSeats: "" });
  const [applicantName1] = useState([
    applicants[0].applicantId.userId.firstName +
      " " +
      applicants[0].applicantId.userId.lastName,
  ]);
  const [applicantName2] = useState([
    applicants[1].applicantId.userId.firstName +
      " " +
      applicants[1].applicantId.userId.lastName,
  ]);
  const [toBeSavedRecs1, setToBeSavedRecs1] = useState([]);
  const [toBeSavedRecs2, setToBeSavedRecs2] = useState([]);
  const [totalAssignedScore1, setTotalAssignedScore1] = useState(0);
  const [totalAssignedScore2, setTotalAssignedScore2] = useState(0);
  const [totalAwardedScore1, setTotalAwardedScore1] = useState(0);
  const [totalAwardedScore2, setTotalAwardedScore2] = useState(0);
  const [saveAlertMsg, setSaveAlertMsg] = useState([]);
  const [question, setQuestion] = useState("");
  const [fullAnswer1, setFullAnswer1] = useState("");
  const [fullAnswer2, setFullAnswer2] = useState("");

  const [fetchFormComponentsAnswers] = useManualQuery(
    GET_COMPONENTS_ANSWERS_BY_FORM_ID_QUERY,
    {
      fetchPolicy: "network-only",
    }
  );

  const [fetchApplicantAnswers] = useManualQuery(
    APPLICANT_ANSWERS_BY_TERM_APPLICANT_ID_QUERY,
    {
      fetchPolicy: "network-only",
    }
  );

  const [editTermAppAnswer] = useMutation(EDIT_TERM_APPLICANT_ANSWER_MUTATE);

  const [editTermApp] = useMutation(EDIT_TERM_APPLICANT_MUTATE);

  const [refreshToken] = useMutation(REFRESH_TOKEN_MUTATION, {
    onError: (err) => {
      console.log(err);
    },
  });

  useEffect(() => {
    if (localStorage.getItem("refreshToken")) {
      onRefreshToken();
    } else window.location.href = `${project_url}/signin/?next=${pathname}`;
  }, []);

  const renderAnswer = (value) => {
      if (value == null) return null;

      const text = Array.isArray(value)
        ? value.join(", ")
        : String(value);

      const urlRegex =
    /(?:https?:\/\/?(?:www\.)?[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}(?:\/[^\s]*)?)/g;

      const parts = text.split(urlRegex);

      return parts.map((part, index) => {
        const isUrl =
          /^(?:https?:\/\/)?(?:www\.)?[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}(?:\/[^\s]*)?$/i.test(
            part
          );

        if (isUrl) {
          const href = part.startsWith("http")
            ? part
            : `https://${part}`;

          return (
            <a
              key={index}
              href={href}
              target="_blank"
              rel="noopener noreferrer"
            >
              {part}
            </a>
          );
        }

        return <React.Fragment key={index}>{part}</React.Fragment>;
      });
    };

  const convertTxtToRichTxt = (txt) => {
    //let contentHTML = draftToHtml(JSON.parse(txt.replace(/'/g, '"')));
    //comment by Sami 30Aug2025
    let contentHTML = draftToHtml(JSON.parse(txt));
    // contentHTML = contentHTML.replace(/<p>/, "");
    contentHTML = contentHTML.replace(
      /<a[^>]*href="([^"]+)"[^>]*>(.*?)<\/a>/gi,
      (match, href, text) => {
        // Remove leading protocols
        href = href.replace(/^(https?:\/\/)+/, "");

        // Prepend https://
        href = `https://${href}`;

        return `<a href="${href}" target="_blank">${text}</a>`;
      }
    );
    const convertedTxt = ReactHtmlParser(contentHTML);
    return convertedTxt;
  };

  const shortenAnswer = (fullAns, length) => {
    //trim the string to the maximum length
    var trimmedString = fullAns.substr(0, length);

    //re-trim if we are in the middle of a word
    trimmedString = trimmedString.substr(
      0,
      Math.min(trimmedString.length, trimmedString.lastIndexOf(" "))
    );
    return trimmedString;
  };

  const saveAwardedScore = async (event) => {
    // Save changed awarded scores for term applicant answers
    if (event.currentTarget.id === "awardedScore1") {
      if (toBeSavedRecs1.length === 0) {
        setSaveAlertMsg({
          title: "Save Score",
          msg:
            "No change in awarded scores for applicant: '" +
            applicantName1 +
            "' to be saved.",
        });
        return;
      }
      for (var i = 0; i < toBeSavedRecs1.length; i++) {
        if (
          toBeSavedRecs1[i].termApplicantAnswerId &&
          toBeSavedRecs1[i].termApplicantId.termApplicantId &&
          toBeSavedRecs1[i].answerId.answerId
        ) {
          const { data, error } = await editTermAppAnswer({
            variables: {
              termApplicantAnswerId: parseInt(
                toBeSavedRecs1[i].termApplicantAnswerId
              ),
              termApplicantId: parseInt(
                toBeSavedRecs1[i].termApplicantId.termApplicantId
              ),
              answerId: parseInt(toBeSavedRecs1[i].answerId.answerId),
              applicantAnswer: toBeSavedRecs1[i].applicantAnswer,
              assignedScore: parseInt(toBeSavedRecs1[i].assignedScore),
              awardedScore: parseInt(toBeSavedRecs1[i].awardedScore),
            },
          });
          if (error) {
            console.log("Error", error, data);
          } else {
            console.log(
              "Success in editing term applicant answer record",
              data.editTermApplicantAnswer.termApplicantAnswer
            );
          }
        }
      }

      // Save total awarded score for a term applicant.length > 0
      if (toBeSavedRecs1 && toBeSavedRecs1.length > 0) {
        const { data: editTermData, error: editTermError } = await editTermApp({
          variables: {
            termApplicantId: parseInt(
              toBeSavedRecs1[0].termApplicantId.termApplicantId
            ),
            termId: parseInt(toBeSavedRecs1[0].termApplicantId.termId.termId),
            totalAssignedScore: parseInt(totalAssignedScore1),
            totalAwardedScore: parseInt(totalAwardedScore1),
            applicationAccepted:
              toBeSavedRecs1[0].termApplicantId.applicationAccepted,
            applicantStatus: toBeSavedRecs1[0].termApplicantId.applicantStatus,
            applicationStatus:
              toBeSavedRecs1[0].termApplicantId.applicationStatus,
          },
        });
        if (editTermError) {
          console.log("Error", editTermError, editTermData);
        } else {
          console.log(
            "Success in editing term applicant record",
            editTermData.editTermApplicant.termApplicant
          );
          applyNewTotalAwardedScores(
            editTermData.editTermApplicant.termApplicant
          );
        }
      }
      setSaveAlertMsg({
        title: "Save Score",
        msg: "Awarded scores for applicant: '" + applicantName1 + "' is saved.",
      });
    } else if (event.currentTarget.id === "awardedScore2") {
      if (toBeSavedRecs2.length === 0) {
        setSaveAlertMsg({
          title: "Save Score",
          msg:
            "No change in awarded scores for applicant: '" +
            applicantName2 +
            "' to be saved.",
        });
        return;
      }
      for (var i = 0; i < toBeSavedRecs2.length; i++) {
        if (
          toBeSavedRecs2[i].termApplicantAnswerId &&
          toBeSavedRecs2[i].termApplicantId.termApplicantId &&
          toBeSavedRecs2[i].answerId.answerId
        ) {
          const { data, error } = await editTermAppAnswer({
            variables: {
              termApplicantAnswerId: parseInt(
                toBeSavedRecs2[i].termApplicantAnswerId
              ),
              termApplicantId: parseInt(
                toBeSavedRecs2[i].termApplicantId.termApplicantId
              ),
              answerId: parseInt(toBeSavedRecs2[i].answerId.answerId),
              applicantAnswer: toBeSavedRecs2[i].applicantAnswer,
              assignedScore: parseInt(toBeSavedRecs2[i].assignedScore),
              awardedScore: parseInt(toBeSavedRecs2[i].awardedScore),
            },
          });
          if (error) {
            console.log("Error", error, data);
          } else {
            console.log(
              "Success in editing term applicant answer record",
              data.editTermApplicantAnswer.termApplicantAnswer
            );
          }
        }
      }

      // Save total awarded score for a term applicant.length > 0
      if (toBeSavedRecs2 && toBeSavedRecs2.length > 0) {
        const { data: editTermData, error: editTermError } = await editTermApp({
          variables: {
            termApplicantId: parseInt(
              toBeSavedRecs2[0].termApplicantId.termApplicantId
            ),
            termId: parseInt(toBeSavedRecs2[0].termApplicantId.termId.termId),
            totalAssignedScore: parseInt(totalAssignedScore2),
            totalAwardedScore: parseInt(totalAwardedScore2),
            applicationAccepted:
              toBeSavedRecs2[0].termApplicantId.applicationAccepted,
            applicantStatus: toBeSavedRecs2[0].termApplicantId.applicantStatus,
            applicationStatus:
              toBeSavedRecs2[0].termApplicantId.applicationStatus,
          },
        });
        if (editTermError) {
          console.log("Error", editTermError, editTermData);
        } else {
          console.log(
            "Success in editing term applicant record",
            editTermData.editTermApplicant.termApplicant
          );
          applyNewTotalAwardedScores(
            editTermData.editTermApplicant.termApplicant
          );
        }
      }
      setSaveAlertMsg({
        title: "Save Score",
        msg: "Awarded scores for applicant: '" + applicantName2 + "' is saved.",
      });
    }
  };

  const openDetailDialog = (question, fullAnswer1, fullAnswer2) => {
    setQuestion(question);
    setFullAnswer1(fullAnswer1);
    setFullAnswer2(fullAnswer2);
    setOpenCompareTextAreaDlg(true);
  };

  const getApplicantAnswers = async () => {
    if (applicants[0].termApplicantId) {
      // Get Applicant 1 answers
      const {
        loading: applicant1AnswersLoading,
        error: applicant1AnswersError,
        data: applicant1AnswersData,
      } = await fetchApplicantAnswers({
        variables: { termApplicantId: parseInt(applicants[0].termApplicantId) },
      });

      if (
        !applicant1AnswersLoading &&
        applicant1AnswersData &&
        applicant1AnswersData.appAnswersBytermApplicantId
      ) {
        // console.log(
        //   "AppAnswers----",
        //   applicantAnswersData.appAnswersBytermApplicantId
        // );
        setApplicant1Answers(applicant1AnswersData.appAnswersBytermApplicantId);
      }
      if (
        applicant1AnswersError &&
        applicant1AnswersError.graphQLErrors &&
        applicant1AnswersError.graphQLErrors[0].message ===
          "Signature has expired"
      ) {
        navigate(`${project_url}/signin`);
      }
    }

    if (applicants[1].termApplicantId) {
      // Get Applicant 2 answers
      const {
        loading: applicant2AnswersLoading,
        error: applicant2AnswersError,
        data: applicant2AnswersData,
      } = await fetchApplicantAnswers({
        variables: { termApplicantId: parseInt(applicants[1].termApplicantId) },
      });

      if (
        !applicant2AnswersLoading &&
        applicant2AnswersData &&
        applicant2AnswersData.appAnswersBytermApplicantId
      ) {
        // console.log(
        //   "AppAnswers----",
        //   applicantAnswersData.appAnswersBytermApplicantId
        // );
        setApplicant2Answers(applicant2AnswersData.appAnswersBytermApplicantId);
      }
      if (
        applicant2AnswersError &&
        applicant2AnswersError.graphQLErrors &&
        applicant2AnswersError.graphQLErrors[0].message ===
          "Signature has expired"
      ) {
        navigate(`${project_url}/signin`);
      }
    }
  };

  const getApplicantData = async () => {
    if (
      applicants[0].termId.formId.formUuid &&
      applicant1Answers.length > 0 &&
      applicant2Answers.length > 0
    ) {
      // Get form components information
      const {
        loading: formComponentsAnswersLoading,
        error: formComponentsAnswersError,
        data: formComponentsAnswersData,
      } = await fetchFormComponentsAnswers({
        variables: { formUuid: applicants[0].termId.formId.formUuid },
      });

      if (
        !formComponentsAnswersLoading &&
        formComponentsAnswersData &&
        formComponentsAnswersData.formComponentAnswerList
      ) {
        // console.log(
        //   "ApplicantFormData----",
        //   formComponentsAnswersData.formComponentAnswerList.componentList
        // );

        let questions =
          formComponentsAnswersData.formComponentAnswerList.componentList;
        let appDetailRows = [];

        for (var i = 0; i < questions.length; i++) {
          if (questions[i].answerTypeId.name !== "content") {
            let appDetailRow = [];
            appDetailRow["question"] = {
              id: i + 1,
              value: convertTxtToRichTxt(questions[i].label),
              checked: true,
            };
            appDetailRow["mandatory"] = questions[i].mandatory;

            let foundAnswer1 = applicant1Answers.filter(
              (item) =>
                item.answerId.componentId.componentId ===
                questions[i].componentId
            );

            let foundAnswer2 = applicant2Answers.filter(
              (item) =>
                item.answerId.componentId.componentId ===
                questions[i].componentId
            );

            if (foundAnswer1 && foundAnswer2) {
              if (
                questions[i].answerTypeId.name === "text" ||
                questions[i].answerTypeId.name === "textarea" ||
                questions[i].answerTypeId.name === "drop_down" ||
                questions[i].answerTypeId.name === "drop_down_state" ||
                questions[i].answerTypeId.name === "drop_down_country" ||
                questions[i].answerTypeId.name === "checkbox_single"
              ) {
                appDetailRow["answer1"] =
                  foundAnswer1.length !== 0
                    ? !questions[i].mandatory &&
                      foundAnswer1[0].applicantAnswer === ""
                      ? "Not provided"
                      : foundAnswer1[0].applicantAnswer
                    : "Not provided";

                appDetailRow["answer2"] =
                  foundAnswer2.length !== 0
                    ? !questions[i].mandatory &&
                      foundAnswer2[0].applicantAnswer === ""
                      ? "Not provided"
                      : foundAnswer2[0].applicantAnswer
                    : "Not provided";

                appDetailRow["assignedScore1"] =
                  foundAnswer1.length !== 0
                    ? !questions[i].mandatory &&
                      foundAnswer1[0].applicantAnswer === ""
                      ? [0]
                      : foundAnswer1[0].assignedScore
                    : [0];

                appDetailRow["assignedScore2"] =
                  foundAnswer2.length !== 0
                    ? !questions[i].mandatory &&
                      foundAnswer2[0].applicantAnswer === ""
                      ? [0]
                      : foundAnswer2[0].assignedScore
                    : [0];

                appDetailRow["awardedScore1"] =
                  foundAnswer1.length !== 0
                    ? !questions[i].mandatory &&
                      foundAnswer1[0].applicantAnswer === ""
                      ? [0]
                      : foundAnswer1[0].awardedScore
                    : [0];

                appDetailRow["awardedScore2"] =
                  foundAnswer2.length !== 0
                    ? !questions[i].mandatory &&
                      foundAnswer2[0].applicantAnswer === ""
                      ? [0]
                      : foundAnswer2[0].awardedScore
                    : [0];
              } else if (
                questions[i].answerTypeId.name === "checkbox_multiple" ||
                questions[i].answerTypeId.name === "radio_button"
              ) {
                appDetailRow["answer1"] = foundAnswer1.map(
                  ({ applicantAnswer }) => applicantAnswer
                );

                if (
                  !questions[i].mandatory &&
                  appDetailRow.answer1.length === 0
                )
                  appDetailRow.answer1 = "Not provided";

                appDetailRow["answer2"] = foundAnswer2.map(
                  ({ applicantAnswer }) => applicantAnswer
                );

                if (
                  !questions[i].mandatory &&
                  appDetailRow.answer2.length === 0
                )
                  appDetailRow.answer2 = "Not provided";

                appDetailRow["assignedScore1"] = foundAnswer1.map(
                  ({ assignedScore }) => assignedScore
                );

                if (
                  !questions[i].mandatory &&
                  appDetailRow.answer1.length === 0
                )
                  appDetailRow.assignedScore1 = [0];

                appDetailRow["assignedScore2"] = foundAnswer2.map(
                  ({ assignedScore }) => assignedScore
                );

                if (
                  !questions[i].mandatory &&
                  appDetailRow.answer2.length === 0
                )
                  appDetailRow.assignedScore2 = [0];

                appDetailRow["awardedScore1"] = foundAnswer1.map(
                  ({ awardedScore }) => awardedScore
                );

                if (
                  !questions[i].mandatory &&
                  appDetailRow.answer1.length === 0
                )
                  appDetailRow.awardedScore1 = [0];

                appDetailRow["awardedScore2"] = foundAnswer2.map(
                  ({ awardedScore }) => awardedScore
                );

                if (
                  !questions[i].mandatory &&
                  appDetailRow.answer2.length === 0
                )
                  appDetailRow.awardedScore2 = [0];
              }
              appDetailRow["answerId1"] = foundAnswer1.map(
                ({ answerId }) => answerId.answerId
              );
              appDetailRow["answerId2"] = foundAnswer2.map(
                ({ answerId }) => answerId.answerId
              );
            }
            appDetailRow["answerList"] = questions[i].answerList.map(
              ({ label }) => label
            );
            appDetailRow["scoreList"] = questions[i].answerList.map(
              ({ score }) => score
            );
            appDetailRow["type1"] = questions[i].answerTypeId.name;
            appDetailRow["type2"] = questions[i].answerTypeId.name;

            appDetailRows.push({
              // index: row.index,
              answerId1: appDetailRow.answerId1,
              answerId2: appDetailRow.answerId2,
              answer1: renderAnswer(appDetailRow.answer1),
              answer2: renderAnswer(appDetailRow.answer2),
              question: appDetailRow.question,
              mandatory: appDetailRow.mandatory,
              answerList: appDetailRow.answerList,
              scoreList: appDetailRow.scoreList,
              type1: appDetailRow.type1,
              type2: appDetailRow.type2,
              assignedScore1: appDetailRow.assignedScore1,
              assignedScore2: appDetailRow.assignedScore2,
              awardedScore1: appDetailRow.awardedScore1,
              awardedScore2: appDetailRow.awardedScore2,
            });
          }
        }
        setApplicantFormData(appDetailRows);
      }
      if (
        formComponentsAnswersError &&
        formComponentsAnswersError.graphQLErrors &&
        formComponentsAnswersError.graphQLErrors[0].message ===
          "Signature has expired"
      ) {
        navigate(`${project_url}/signin`);
      }
    }
  };

  useEffect(() => {
    (() => getApplicantData())();
  }, [applicants, applicant1Answers, applicant2Answers]);

  useEffect(() => {
    (() => getApplicantAnswers())();
  }, [applicants]);

  useEffect(() => {
    let rows = [];
    //first row with col span
    rows.push({
      index: 0,
      answerId1: "",
      answerId2: "",
      answer1: "",
      question: "",
      mandatory: "",
      answerList: [],
      scoreList: [],
      type1: "",
      assignedScore1: "",
      awardedScore1: "",
      answer2: "",
      type2: "",
      assignedScore2: "",
      awardedScore2: "",
    });

    //second row with col span for showing total scores
    rows.push({
      index: 1,
      answerId1: "",
      answerId2: "",
      answer1: "",
      question: "",
      mandatory: "",
      answerList: [],
      scoreList: [],
      type1: "",
      assignedScore1: "",
      awardedScore1: "",
      answer2: "",
      type2: "",
      assignedScore2: "",
      awardedScore2: "",
    });

    for (var i = 0; i < applicantFormData.length; i++) {
      let row = [];
      row["index"] = i + 2;
      row["answerId1"] = applicantFormData[i].answerId1;
      row["answer1"] = applicantFormData[i].answer1;
      row["question"] = applicantFormData[i].question;
      row["mandatory"] = applicantFormData[i].mandatory;
      row["answerList"] = applicantFormData[i].answerList;
      row["scoreList"] = applicantFormData[i].scoreList;
      row["type1"] = applicantFormData[i].type1;
      row["assignedScore1"] = applicantFormData[i].assignedScore1;
      row["awardedScore1"] = applicantFormData[i].awardedScore1;
      row["answerId2"] = applicantFormData[i].answerId2;
      row["answer2"] = applicantFormData[i].answer2;
      row["type2"] = applicantFormData[i].type2;
      row["assignedScore2"] = applicantFormData[i].assignedScore2;
      row["awardedScore2"] = applicantFormData[i].awardedScore2;
      rows.push({
        index: row.index,
        answerId1: row.answerId1,
        answer1:
          row.type1 === "checkbox_single"
            ? row.answer1 === "true"
              ? "Checked"
              : "Unchecked"
            : row.answer1,
        question: row.question,
        mandatory: row.mandatory,
        answerList: row.answerList,
        scoreList: row.scoreList,
        type1: row.type1,
        assignedScore1: Array.isArray(row.assignedScore1)
          ? row.assignedScore1
          : [row.assignedScore1],
        awardedScore1: Array.isArray(row.awardedScore1)
          ? row.awardedScore1
          : [row.awardedScore1],
        answerId2: row.answerId2,
        answer2:
          row.type2 === "checkbox_single"
            ? row.answer2 === "true"
              ? "Checked"
              : "Unchecked"
            : row.answer2,
        type2: row.type2,
        assignedScore2: Array.isArray(row.assignedScore2)
          ? row.assignedScore2
          : [row.assignedScore2],
        awardedScore2: Array.isArray(row.awardedScore2)
          ? row.awardedScore2
          : [row.awardedScore2],
      });
    }
    if (quesList.length === 0) {
      // set Question list for first time
      let quesList = [];
      applicantFormData.map((item) => {
        item.type1 !== "content" && quesList.push(item.question);
      });
      setQuesList(quesList);
    }
    setApplicantsDetail(rows);
    setDetailRows(rows);
  }, [applicantFormData]);

  useEffect(() => {
    let newList = [];
    if (applicantsDetail.length === 0) return;
    applicantsDetail.map((row, index) => {
      // to show applicant name and total scores
      if (index === 0 || index === 1) newList.push(row);
      const quesIdx = quesList.findIndex(
        (item) => item.id === row.question.id && item.checked
      );
      if (quesIdx !== -1) newList.push(row);
    });
    setDetailRows(newList);
  }, [quesList, applicantsDetail]);

  const onRefreshToken = async () => {
    const { data: refreshData, error: refreshError } = await refreshToken({
      variables: { refreshToken: localStorage.getItem("refreshToken") },
    });
    if (refreshError) {
      if (
        refreshError.graphQLErrors[0].message ===
        "You do not have permission to perform this action"
      )
        window.location.href = `${project_url}/signin/?next=${pathname}`;
      if (refreshError.graphQLErrors[0].message === "Signature has expired")
        window.location.href = `${project_url}/signin/?next=${pathname}`;
    }
    if (refreshData && refreshData.refreshToken) {
      localStorage.setItem("token", refreshData.refreshToken.token);
      localStorage.setItem(
        "refreshToken",
        refreshData.refreshToken.refreshToken
      );
      client.setHeader(
        "Authorization",
        `JWT ${refreshData.refreshToken.token}`
      );
      setLoadContent(true);
    }
  };

  const classes = useStyles();

  const columns = [
    {
      field: "assignedScore1",
      headerName: "Assigned Score",
      headerClassName: "super-app-theme--header",
      minWidth: 100,
      height: 50,
      //    flex: 1,
      sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
      colSpan: (value, row) => {
        if (row.index === 0) {
          return 3;
        }
        return undefined;
      },
      renderCell: (rows) => {
        if (rows.row.index === 0) {
          return (
            <>
              <Typography
                style={{ paddingRight: 5, paddingBottom: 2 }}
                variant="h2"
              >
                Applicant:
              </Typography>
              <Typography variant="h3">{applicantName1}</Typography>
            </>
          );
        }
        if (rows.row.index === 1) {
          return (
            <Typography
              className={classes.dataGridFooterTextStyle}
              variant="h2"
            >
              {totalAssignedScore1}
            </Typography>
          );
        }
        if (!rows.row.assignedScore1 || rows.row.assignedScore1 == "N/A")
          return <div>{rows.row.assignedScore1}</div>;
        else {
          return (
            <Box
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              {rows.row.assignedScore1.map((as, index) => (
                <Box
                  pt={0.5}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    height: 40,
                  }}
                >
                  {as}
                </Box>
              ))}
            </Box>
          );
        }
      },
    },
    {
      field: "awardedScore1",
      headerClassName: "super-app-theme--header",
      headerName: "Awarded Score",
      minWidth: 100,
      height: 50,
      //  flex: 1,
      sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
      renderCell: (rows) => {
        if (rows.row.index === 1) {
          return (
            <Typography
              className={classes.dataGridFooterTextStyle}
              variant="h2"
            >
              {totalAwardedScore1}
            </Typography>
          );
        }
        if (rows.row.awardedScore1 == "N/A")
          return <div>{rows.row.awardedScore1}</div>;
        else {
          return (
            <Box
              pb={0.5}
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              {rows.row.awardedScore1 &&
                rows.row.awardedScore1.map((aw, index) => (
                  <Box pt={0.5}>
                    <TextField
                      className={classes.textFieldStyle}
                      name="awardedScore1"
                      variant="outlined"
                      defaultValue={aw}
                      type="number"
                      InputProps={{
                        inputProps: { min: 0, pattern: "[0-9]*" },
                      }}
                      onKeyPress={(e) => {
                        if (e?.key === "-" || e?.key === "+") {
                          e.preventDefault();
                        }
                      }}
                      onChange={(e) =>
                        updateAssignedScore(
                          e.target.value,
                          rows.row.index,
                          index,
                          "awardedScore1"
                        )
                      }
                    />
                  </Box>
                ))}
            </Box>
          );
        }
      },
    },
    {
      field: "applicantAnswer1",
      headerName: "Applicant Answer",
      headerClassName: "super-app-theme--header",
      width: 400,
      minHeight: 50,
      flex: 2,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (rows) => {
        if (rows.row.index === 1) {
          return (
            <Typography
              className={classes.dataGridFooterTextStyle}
              variant="h2"
            >
              Total Score
            </Typography>
          );
        }
        if (rows.row.type1 === "textarea") {
          if (rows.row.answer1.length < 100) {
            return <Typography variant="h3">{rows.row.answer1}</Typography>;
          } else {
            return (
              <Typography
                style={{
                  wordBreak: "break-word",
                }}
                variant="h3"
              >
                {shortenAnswer(rows.row.answer1, 110) + " ..."}
                <Link
                  style={{
                    cursor: "pointer",
                  }}
                  onClick={() =>
                    openDetailDialog(
                      rows.row.question.value,
                      rows.row.answer1,
                      rows.row.answer2
                    )
                  }
                >
                  more
                </Link>
              </Typography>
            );
          }
        } else if (
          rows.row.type1 === "text" ||
          rows.row.type1 === "drop_down" ||
          rows.row.type1 === "drop_down_state" ||
          rows.row.type1 === "drop_down_country"
        ) {
          return <Typography variant="h3">{rows.row.answer1}</Typography>;
        } else if (rows.row.type1 === "radio_button") {
          return (
            <Grid
              container
              spacing={1}
              style={{ paddingTop: 10, paddingBottom: 5 }}
            >
              <Grid
                item
                xs={12}
                style={{
                  paddingLeft: rows.row.answer1 !== "Not provided" && 15,
                }}
              >
                <FormControl>
                  <RadioGroup
                    aria-labelledby="demo-radio-buttons-group-label"
                    defaultValue="female"
                    name="radio-buttons-group"
                  >
                    {rows.row.answer1 !== "Not provided" ? (
                      rows.row.answer1.map((item, i) => (
                        <FormControlLabel
                          value={item}
                          onClick={(e) => e.preventDefault()}
                          style={{ cursor: "default" }}
                          control={
                            <Radio
                              disableRipple
                              onClick={(e) => e.preventDefault()}
                              style={{ cursor: "default", paddingLeft: 0 }}
                              checked={true}
                              tabIndex={"-1"}
                            />
                          }
                          label={item}
                        />
                      ))
                    ) : (
                      <Typography variant="h3">{rows.row.answer1}</Typography>
                    )}
                  </RadioGroup>
                </FormControl>
              </Grid>
            </Grid>
          );
        } else if (rows.row.type1 === "checkbox_multiple") {
          return (
            <Grid
              container
              spacing={1}
              style={{ paddingTop: 10, paddingBottom: 5 }}
            >
              <Grid item xs={12}>
                {rows.row.answer1 !== "Not provided" ? (
                  rows.row.answer1.map((item, i) => (
                    <Box
                      style={{
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <Box
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                        }}
                      >
                        <Checkbox
                          disabled
                          checked={true}
                          style={{ color: "#0D47A1", paddingLeft: 0 }}
                          tabIndex={"-1"}
                        />
                        <Typography variant="h3">{item}</Typography>
                      </Box>
                    </Box>
                  ))
                ) : (
                  <Typography variant="h3">{rows.row.answer1}</Typography>
                )}
              </Grid>
            </Grid>
          );
        } else if (rows.row.type1 === "checkbox_single") {
          return (
            <Grid container>
              <Grid item xs={12}>
                {rows.row.answer !== "Not provided"
                ?
                  <Box
                    style={{
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <Box
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                      }}
                    >
                      <Checkbox
                        disabled
                        checked={rows.row.answer1}
                        style={{ color: "#0D47A1", paddingLeft: 0 }}
                        tabIndex={"-1"}
                      />
                    </Box>
                  </Box>
                :
                <Typography variant="h3">{rows.row.answer1}</Typography>
              }
              </Grid>
            </Grid>
          );
        }
      },
    },
    {
      field: "question",
      headerClassName: "super-app-theme--header",
      headerName: "Question",
      minWidth: 100,
      height: 50,
      flex: 2,
      sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
      renderCell: (rows) => {
        let title = (
          <Box
            style={{
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Grid
              container
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                paddingLeft: 10,
              }}
            >
              <Grid item xs={9}>
                <Typography variant="h2">Answer</Typography>
              </Grid>

              <Grid item xs={3} style={{ textAlign: "center" }}>
                <Typography style={{ paddingTop: 3 }} variant="h2">
                  Assigned Score
                </Typography>
              </Grid>
            </Grid>
            {rows.row.answerList.map(
              (item, index) =>
                rows.row.type1 === "checkbox_multiple" && (
                  <Grid
                    container
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                    }}
                  >
                    <Grid
                      item
                      xs={9}
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                      }}
                    >
                      <Checkbox
                        disabled
                        checked={false}
                        style={{ padding: 5 }}
                      />

                      <Typography variant="h3">{item}</Typography>
                    </Grid>
                    <Grid item xs={3} style={{ textAlign: "center" }}>
                      <Typography style={{ paddingTop: 3 }} variant="h2">
                        {rows.row.scoreList[index]}
                      </Typography>
                    </Grid>
                  </Grid>
                )
            )}
            {rows.row.answerList.map(
              (item, index) =>
                rows.row.type1 === "radio_button" && (
                  <Grid
                    container
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                    }}
                  >
                    <Grid
                      item
                      xs={9}
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                      }}
                    >
                      <FormControl>
                        <RadioGroup
                          aria-labelledby="demo-radio-buttons-group-label"
                          defaultValue="female"
                          name="radio-buttons-group"
                          style={{ paddingLeft: 10 }}
                        >
                          <FormControlLabel
                            value={item}
                            control={
                              <Radio checked={false} style={{ padding: 5 }} />
                            }
                            label={
                              <Typography
                                variant="h3"
                                style={{ color: "black" }}
                              >
                                {item}
                              </Typography>
                            }
                          />
                        </RadioGroup>
                      </FormControl>
                    </Grid>
                    <Grid item xs={3} style={{ textAlign: "center" }}>
                      <Typography style={{ paddingTop: 3 }} variant="h2">
                        {rows.row.scoreList[index]}
                      </Typography>
                    </Grid>
                  </Grid>
                )
            )}
          </Box>
        );
        if (
          rows.row.type2 === "radio_button" ||
          rows.row.type2 === "checkbox_multiple"
        )
          if (rows.row.mandatory)
            return (
              <Box
                style={{ display: "flex", alignItems: "center", width: "100%" }}
              >
                <StyledTooltip title={title}>
                  <Box pr={1} pt={0.5} style={{ textAlign: "left" }}>
                    <InfoIcon
                      height={24}
                      color="action"
                      style={{ cursor: "pointer" }}
                    />
                  </Box>
                </StyledTooltip>
                <StyledTooltipCom title="required field">
                  <Typography
                    variant="h3"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      color: "#E53935",
                      paddingLeft: 5,
                      paddingRight: 5,
                    }}
                  >
                    *
                  </Typography>
                </StyledTooltipCom>
                <Typography variant="h2">{rows.row.question.value}</Typography>
              </Box>
            );
          else
            return (
              <Box
                style={{ display: "flex", alignItems: "center", width: "100%" }}
              >
                <StyledTooltip title={title}>
                  <Box pr={1} pt={0.5} style={{ textAlign: "left" }}>
                    <InfoIcon
                      height={24}
                      color="action"
                      style={{ cursor: "pointer" }}
                    />
                  </Box>
                </StyledTooltip>
                <Typography variant="h2">{rows.row.question.value}</Typography>
              </Box>
            );
        else if (rows.row.mandatory)
          return (
            <Box
              pb={0.25}
              style={{
                display: "flex",
                flexDirection: "row",
              }}
            >
              <StyledTooltipCom title="required field">
                <Typography
                  variant="h3"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    color: "#E53935",
                    paddingLeft: 5,
                    paddingRight: 5,
                  }}
                >
                  *
                </Typography>
              </StyledTooltipCom>
              <Typography variant="h2">{rows.row.question.value}</Typography>
            </Box>
          );
        else
          return (
            <Typography variant="h2">{rows.row.question.value}</Typography>
          );
      },
    },
    {
      field: "applicantAnswer2",
      headerName: "Applicant Answer",
      headerClassName: "super-app-theme--header",
      width: 400,
      minHeight: 50,
      flex: 2,
      sortable: false,
      disableColumnMenu: true,
      colSpan: (value, row) => {
        if (row.index === 0) return 3;
        return undefined;
      },
      renderCell: (rows) => {
        if (rows.row.index === 0) {
          return (
            <>
              <Typography
                style={{ paddingRight: 5, paddingBottom: 2 }}
                variant="h2"
              >
                Applicant:
              </Typography>
              <Typography variant="h3">{applicantName2}</Typography>
            </>
          );
        }
        if (rows.row.index === 1) {
          return (
            <Typography
              className={classes.dataGridFooterTextStyle}
              variant="h2"
            >
              Total Score
            </Typography>
          );
        }
        if (rows.row.type2 === "textarea") {
          if (rows.row.answer2.length < 100) {
            return <Typography variant="h3">{rows.row.answer2}</Typography>;
          } else {
            return (
              <Typography
                style={{
                  wordBreak: "break-word",
                }}
                variant="h3"
              >
                {shortenAnswer(rows.row.answer2, 110) + " ..."}
                <Link
                  style={{
                    cursor: "pointer",
                  }}
                  onClick={() =>
                    openDetailDialog(
                      rows.row.question.value,
                      rows.row.answer1,
                      rows.row.answer2
                    )
                  }
                >
                  more
                </Link>
              </Typography>
            );
          }
        } else if (
          rows.row.type2 === "text" ||
          rows.row.type2 === "drop_down" ||
          rows.row.type2 === "drop_down_state" ||
          rows.row.type2 === "drop_down_country"
        ) {
          return <Typography variant="h3">{rows.row.answer2}</Typography>;
        } else if (rows.row.type2 === "radio_button") {
          return (
            <Grid
              container
              spacing={1}
              style={{ paddingTop: 10, paddingBottom: 5 }}
            >
              <Grid
                item
                xs={12}
                style={{
                  paddingLeft: rows.row.answer2 !== "Not provided" && 15,
                }}
              >
                <FormControl>
                  <RadioGroup
                    aria-labelledby="demo-radio-buttons-group-label"
                    defaultValue="female"
                    name="radio-buttons-group"
                  >
                    {rows.row.answer2 !== "Not provided" ? (
                      rows.row.answer2.map((item, i) => (
                        <FormControlLabel
                          value={item}
                          onClick={(e) => e.preventDefault()}
                          style={{ cursor: "default" }}
                          control={
                            <Radio
                              disableRipple
                              onClick={(e) => e.preventDefault()}
                              style={{ cursor: "default", paddingLeft: 0 }}
                              checked={true}
                              tabIndex={"-1"}
                            />
                          }
                          label={
                            <Typography
                              variant="h3"
                              style={{ color: "#1d1f21" }}
                            >
                              {item}
                            </Typography>
                          }
                        />
                      ))
                    ) : (
                      <Typography variant="h3">{rows.row.answer2}</Typography>
                    )}
                  </RadioGroup>
                </FormControl>
              </Grid>
            </Grid>
          );
        } else if (rows.row.type2 === "checkbox_multiple") {
          return (
            <Grid
              container
              spacing={1}
              style={{ paddingTop: 10, paddingBottom: 5 }}
            >
              <Grid item xs={12}>
                {rows.row.answer2 !== "Not provided" ? (
                  rows.row.answer2.map((item, i) => (
                    <Box
                      style={{
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <Box
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                        }}
                      >
                        <Checkbox
                          disabled
                          checked={true}
                          style={{ color: "#0D47A1", paddingLeft: 0 }}
                          tabIndex={"-1"}
                        />
                        <Typography variant="h3">{item}</Typography>
                      </Box>
                    </Box>
                  ))
                ) : (
                  <Typography variant="h3">{rows.row.answer2}</Typography>
                )}
              </Grid>
            </Grid>
          );
        } else if (rows.row.type2 === "checkbox_single") {
          return (
            <Grid container>
              <Grid item xs={12}>
                {rows.row.answer !== "Not provided"
                ?
                  <Box
                    style={{
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <Box
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                      }}
                    >
                      <Checkbox
                        disabled
                        checked={rows.row.answer2}
                        style={{ color: "#0D47A1", paddingLeft: 0 }}
                        tabIndex={"-1"}
                      />
                    </Box>
                  </Box>
                :
                <Typography variant="h3">{rows.row.answer2}</Typography>
              }
              </Grid>
            </Grid>
          );
        }
      },
    },
    {
      field: "awardedScore2",
      headerClassName: "super-app-theme--header",
      headerName: "Awarded Score",
      minWidth: 100,
      height: 50,
      //  flex: 1,
      sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
      renderCell: (rows) => {
        if (rows.row.index === 1) {
          return (
            <Typography
              className={classes.dataGridFooterTextStyle}
              variant="h2"
            >
              {totalAwardedScore2}
            </Typography>
          );
        }
        if (!rows.row.assignedScore2 || rows.row.awardedScore2 == "N/A")
          return <div>{rows.row.awardedScore2}</div>;
        else {
          return (
            <Box
              pb={0.5}
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              {rows.row.awardedScore2.map((aw, index) => (
                <Box pt={0.5}>
                  <TextField
                    className={classes.textFieldStyle}
                    name="awardedScore2"
                    variant="outlined"
                    defaultValue={aw}
                    type="number"
                    InputProps={{
                      inputProps: { min: 0, pattern: "[0-9]*" },
                    }}
                    onKeyPress={(e) => {
                      if (e?.key === "-" || e?.key === "+") {
                        e.preventDefault();
                      }
                    }}
                    onChange={(e) =>
                      updateAssignedScore(
                        e.target.value,
                        rows.row.index,
                        index,
                        "awardedScore2"
                      )
                    }
                  />
                </Box>
              ))}
            </Box>
          );
        }
      },
    },
    {
      field: "assignedScore2",
      headerName: "Assigned Score",
      headerClassName: "super-app-theme--header",
      minWidth: 100,
      height: 50,
      //  flex: 1,
      sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
      renderCell: (rows) => {
        if (rows.row.index === 1) {
          return (
            <Typography
              className={classes.dataGridFooterTextStyle}
              variant="h2"
            >
              {totalAssignedScore2}
            </Typography>
          );
        }
        if (rows.row.assignedScore2 == "N/A")
          return <div>{rows.row.assignedScore2}</div>;
        else {
          return (
            <Box
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              {rows.row.awardedScore2 &&
                rows.row.assignedScore2.map((as, index) => (
                  <Box
                    pt={0.5}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      height: 40,
                    }}
                  >
                    {as}
                  </Box>
                ))}
            </Box>
          );
        }
      },
    },
  ];
  const updateAssignedScore = (value, index, scoreIdx, applicant) => {
    const foundAppDetailRow = applicantsDetail.find(
      (appDetail) => appDetail.index === index
    );
    if (applicant === "awardedScore1") {
      foundAppDetailRow.awardedScore1[scoreIdx] = parseInt(value);
      const foundDetailRow = detailRows.find((row) => row.index === index);
      foundDetailRow.awardedScore1[scoreIdx] = parseInt(value);

      const foundAppAnswerRec1 = applicant1Answers.find(
        (applicantAnswer) =>
          applicantAnswer.answerId.answerId ===
          foundDetailRow.answerId1[scoreIdx]
      );
      if (foundAppAnswerRec1) {
        foundAppAnswerRec1.awardedScore = parseInt(value);
        toBeSavedRecs1.push(foundAppAnswerRec1);
        setToBeSavedRecs1(toBeSavedRecs1);
      }

      setApplicantsDetail(prev =>
        prev.map(row => {
          if (row.index !== index) return row;

          const awardedScore1 = [...row.awardedScore1];
          awardedScore1[scoreIdx] = parseInt(value);

          return {
            ...row,
            awardedScore1,
          };
        })
      );

    } else if (applicant === "awardedScore2") {
      foundAppDetailRow.awardedScore2[scoreIdx] = parseInt(value);
      const foundDetailRow = detailRows.find((row) => row.index === index);
      foundDetailRow.awardedScore2[scoreIdx] = parseInt(value);

      const foundAppAnswerRec2 = applicant2Answers.find(
        (applicantAnswer) =>
          applicantAnswer.answerId.answerId ===
          foundDetailRow.answerId2[scoreIdx]
      );
      if (foundAppAnswerRec2) {
        foundAppAnswerRec2.awardedScore = parseInt(value);
        toBeSavedRecs2.push(foundAppAnswerRec2);
        setToBeSavedRecs2(toBeSavedRecs2);
      }
      setApplicantsDetail(prev =>
        prev.map(row => {
          if (row.index !== index) return row;

          const awardedScore2 = [...row.awardedScore2];
          awardedScore2[scoreIdx] = parseInt(value);

          return {
            ...row,
            awardedScore2,
          };
        })
      );
    }
  };
  const customFooter = () => {
    let calAssignedScore1 = 0;
    let calAwardedScore1 = 0;
    let calAssignedScore2 = 0;
    let calAwardedScore2 = 0;
    applicantsDetail.map((item, index) => {
      if (index < 2) return;
      item.assignedScore1 &&
        item.assignedScore1 !== "N/A" &&
        item.assignedScore1.map((ass) => {
          if (parseInt(ass)) calAssignedScore1 += ass;
        });
      item.awardedScore1 &&
        item.awardedScore1 !== "N/A" &&
        item.awardedScore1.map((aw) => {
          if (parseInt(aw)) calAwardedScore1 += aw;
        });
      item.assignedScore2 &&
        item.assignedScore2 !== "N/A" &&
        item.assignedScore2.map((ass) => {
          if (parseInt(ass)) calAssignedScore2 += ass;
        });
      item.awardedScore2 &&
        item.awardedScore2 !== "N/A" &&
        item.awardedScore2.map((aw) => {
          if (parseInt(aw)) calAwardedScore2 += aw;
        });
    });
    setTotalAssignedScore1(calAssignedScore1);
    setTotalAssignedScore2(calAssignedScore2);
    setTotalAwardedScore1(calAwardedScore1);
    setTotalAwardedScore2(calAwardedScore2);

    return (
      <Grid container className={classes.dataGridFooterStyle}>
        <Grid item xs={1}>
          <Typography
            className={classes.dataGridFooterTextStyle}
            style={{ textAlign: "left", paddingLeft: 40 }}
          >
            {calAssignedScore1}
          </Typography>
        </Grid>
        <Grid item xs={1}>
          <Typography
            style={{ textAlign: "left", paddingLeft: 25 }}
            className={classes.dataGridFooterTextStyle}
          >
            {calAwardedScore1}
          </Typography>
        </Grid>
        <Grid item xs={8} style={{ textAlign: "center" }}>
          <Typography className={classes.dataGridFooterTextStyle}>
            Total Score
          </Typography>
        </Grid>
        <Grid item xs={1}>
          <Typography
            style={{ textAlign: "left", paddingLeft: 57 }}
            className={classes.dataGridFooterTextStyle}
          >
            {calAwardedScore2}
          </Typography>
        </Grid>
        <Grid item xs={1}>
          <Typography
            style={{ textAlign: "left", paddingLeft: 50 }}
            className={classes.dataGridFooterTextStyle}
          >
            {calAssignedScore2}
          </Typography>
        </Grid>
      </Grid>
    );
  };
  if (loadContent && detailRows.length > 2)
    return (
      <>
        <Grid
          container
          spacing={1}
          style={{
            display: "flex",
            alignItems: "center",
            marginTop: 20,
          }}
        >
          <Grid
            item
            xs={12}
            style={{ display: "flex", justifyContent: "flex-end" }}
          >
            <Button
              variant="contained"
              color="primary"
              className={classes.buttonStyle}
              onClick={() => setOpenSelQuesDlg(true)}
            >
              Select Questions
            </Button>
          </Grid>
        </Grid>
        <Box style={{ marginTop: 20 }}>
          <DataGrid
            className={classes.dataGridStyle}
            columns={columns}
            rows={detailRows}
            showCellRightBorder={true}
            getRowId={(row) => row.index}
            autoHeight={true}
            getRowClassName={(rows) => {
              if (rows.row.index % 2 === 0) return "even";
              else return "odd";
            }}
            getCellClassName={(rows) => {
              if (rows.row.index === 0) return "colSpan";
              if (rows.row.index === 1) return "totalScore";
            }}
            getRowHeight={() => "auto"}
            //experimentalFeatures={{ newEditingApi: true }}
            hideFooterSelectedRowCount
            slots={{
              footer: customFooter,
            }}
          />
        </Box>
        <Grid
          container
          spacing={1}
          style={{
            display: "flex",
            alignItems: "center",
            marginTop: 20,
          }}
        >
          <Grid
            item
            xs={6}
            style={{ display: "flex", justifyContent: "flex-start" }}
          >
            <Button
              variant="contained"
              color="primary"
              id="awardedScore1"
              className={classes.buttonStyle}
              //  style={{width:180/*, marginLeft:15*/}}
              onClick={(e) => {
                saveAwardedScore(e);
                setToBeSavedRecs1([]);
              }}
            >
              Save Awarded Score
            </Button>
          </Grid>
          <Grid
            item
            xs={6}
            style={{ display: "flex", justifyContent: "flex-end" }}
          >
            <Button
              variant="contained"
              color="primary"
              id="awardedScore2"
              className={classes.buttonStyle}
              //    style={{width:180/*, marginRight:15*/}}
              onClick={(e) => {
                saveAwardedScore(e);
                setToBeSavedRecs2([]);
              }}
            >
              Save Awarded Score
            </Button>
          </Grid>
        </Grid>
        {openSelQuesDlg && (
          <SelectQuestionDialog
            quesList={quesList}
            applySelections={(selQuesLst) => {
              setOpenSelQuesDlg(false);
              setQuesList(selQuesLst);
              applySelectedQues(selQuesLst);
            }}
            closeDialog={() => setOpenSelQuesDlg(false)}
          />
        )}
        {saveAlertMsg.msg && (
          <AlertDialog
            title={saveAlertMsg.title}
            type={saveAlertMsg.type}
            contentMsg={saveAlertMsg.msg}
            closeDialog={() => setSaveAlertMsg([])}
          />
        )}
        {openCompareTextAreaDlg && (
          <CompareTextAreaDialog
            appName1={applicantName1}
            appName2={applicantName2}
            question={question}
            fullAnswer1={fullAnswer1}
            fullAnswer2={fullAnswer2}
            closeDialog={() => setOpenCompareTextAreaDlg(false)}
          />
        )}
      </>
    );
  else return;
}

export default ApplicantsOneOnOne;
